<template>
  <div class="wrap_two">
    <p class="type">
      <span class="title"> 2024 年 01 月税款计算表</span>
      <total-tax-info
          v-if="Boolean(currentItem)"
          :current-ans="userAnswer"
      />
    </p>
    <div class="opt-btn">
      <el-space :size="14">
        <!-- <el-button type="primary" >添加</el-button> -->
        <el-button type="primary" @click="changeTab">重新计算</el-button>
      </el-space>
      <el-space :size="14">
        <el-button type="primary" plain>导出</el-button>
        <el-button type="primary" plain>展开查询条件</el-button>
        <el-button type="primary" plain>更多操作</el-button>
      </el-space>
    </div>

    <div class="opera-bar">
      所得项目：
      <el-select
          size="small"
          v-model="currentItem"
          style="width: 180px"
          :clearable="false"
          popper-class="disable-option-dark-global"
          placeholder="请选择"
          @change="changeItem"
      >
        <el-option
            label="正常工资薪金所得"
            value="正常工资薪金所得"/>
        <el-option
            disabled
            label="全年一次性奖金收入"
            value="全年一次性奖金收入"/>
        <el-option
            disabled
            label="劳务报酬（一般、法律援助补贴、其他非连续劳务）"
            value="劳务报酬（一般、法律援助补贴、其他非连续劳务）"/>
      </el-select>

      <div class="grow"></div>

      <div class="item">申报总人数：{{ userAnswer.length }}人</div>
      <div class="item last">应补退税额：{{ totalInfo.Answer_TaxCreditPayable || '0.00' }}元</div>
    </div>

    <vxe-table
        border
        keep-source
        ref="tableRef"
        :max-height="maxHeight"
        :data="tableData"
        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
    >
      <vxe-column field="employeesNo" title="工号" width="150"/>
      <vxe-column field="name" title="姓名" width="150"/>
      <vxe-column field="certificateType" title="证件类型" width="150"/>
      <vxe-column field="idNumber" title="证件号码" width="150"/>
      <vxe-column title="所得项目" width="150">
        <template #default>
          <span>正常工资薪金</span>
        </template>
      </vxe-column>
      <vxe-column field="Answer_CurrentIncome" title="累计收入" width="150" :edit-render="{}">
        <template #edit="{ row }">
          <el-input-number placeholder="请输入" @change="(val) =>incomeChange(val,row)"
                           v-model="row.Answer_CurrentIncome" style="width: 130px;" :controls="false" :precision="2"/>
        </template>
        <template #default="{ row }">
          <span>{{ row.Answer_CurrentIncome }}</span>
        </template>
      </vxe-column>
      <vxe-column field="Answer_CurrentExemptIncome" title="累计免税收入" width="150" :edit-render="{}">
        <template #edit="{ row }">
          <el-input-number placeholder="请输入" v-model="row.Answer_CurrentExemptIncome" style="width: 130px;"
                           :controls="false" :precision="2"/>
        </template>
        <template #default="{ row }">
          <span>{{ row.Answer_CurrentExemptIncome }}</span>
        </template>
      </vxe-column>
      <vxe-column field="CumulativeExpenseReduction" title="累计减除费用" width="150"/>
      <!-- <template #edit="{ row }">
                  <el-input-number placeholder="请输入" @change="(val) =>incomeChange(val,row)" v-model="row.total_kc" style="width: 130px;" :controls="false" :precision="2"   />
              </template>
              <template #default="{ row }">
                  <span>{{ row.total_kc}}</span>
              </template> -->
      <vxe-column field="total_kc" title="累计扣除项目合计" width="150">

      </vxe-column>
      <vxe-column field="Answer_PreDeductibleContributions" title="累计准予扣除的捐款额" width="150"/>
      <vxe-column field="CumulativeTaxableIncome" title="累计应纳税所得额" width="150"/>
      <vxe-column field="TaxRate" title="税率/预扣率" width="150"/>
      <vxe-column field="CalculateDeductionsQuickly" title="速算扣除数" width="150"/>
      <vxe-column field="CumulativeTaxPayable" title="累计应纳税额" width="150"/>
      <vxe-column field="TaxRelief" title="累计减免税额" width="150"/>
      <vxe-column field="" title="累计应扣缴税额" width="150"/>
      <vxe-column field="Answer_TheAmountTaxWithheld" title="已扣缴税额" width="150">
        <template #default>
          <span></span>
        </template>
      </vxe-column>
      <vxe-column field="CumulativeTaxPayable" title="应补(退)税额" width="150"/>
    </vxe-table>
  </div>
</template>

<script setup>
import Big from 'big.js';
import {useTaxStore} from '@/store/modules/tax.js'
import {onBeforeUnmount, onMounted, onUnmounted} from 'vue';
import TotalTaxInfo from "./totalTaxInfo.vue";

const taxStore = useTaxStore()
const {userAnswer} = storeToRefs(taxStore);
const tableData = ref([])
const tableRef = ref(null)
let totalInfo = ref({})

const genTableList = () => {
  tableData.value = []
  userAnswer.value.map(item => {
    const row = {
      employeesNo: item.employeesNo,
      name: item.name,
      certificateType: item.certificateType,
      idNumber: item.idNumber,
      CumulativeExpenseReduction: 5000,
      TaxRate: '3%',
      ...item,
    }
    row.total_kc = computeKc(row)
    let nrow = incomeChange(row.Answer_CurrentIncome, row)
    tableData.value.push({
      ...nrow
    })
  })
  save()
  let Answer_TaxCreditPayable = new Big(0)
  userAnswer.value.forEach(row => {
    Answer_TaxCreditPayable = Answer_TaxCreditPayable.plus(row.Answer_TaxCreditPayable || 0)
  })
  totalInfo.value.Answer_TaxCreditPayable = Answer_TaxCreditPayable.toFixed(2)
  console.log(tableData.value)
}

//累计扣除项目合计
function computeKc(row) {
  let total = new Big(0)
  total = total.plus(row['Answer_BasicEndowmentInsurance'] || 0)
      .plus(row['Answer_BasicMedicalInsurance'] || 0)
      .plus(row['Answer_UnemploymentInsurancePremium'] || 0)
      .plus(row['Answer_HousingAccumulationFund'] || 0)
      .plus(row['Answer_CumulativeInfantCare'] || 0)
      .plus(row['Answer_CumulativeChildEducation'] || 0)
      .plus(row['Answer_CumulativeContinuingEducation'] || 0)
      .plus(row['Answer_AccumulatedHousingLoanInterest'] || 0)
      .plus(row['Answer_AccumulatedHousingRent'] || 0)
      .plus(row['Answer_SupportTheElderlyCumulatively'] || 0)
      .plus(row['Answer_AccumulatedInfantChild'] || 0)
  return total.valueOf()
}

const save = () => {
  userAnswer.value = userAnswer.value.map(item => {
    const obj = tableData.value.find(it => it.idNumber == item.idNumber)
    if (obj) {
      item['Answer_TaxCreditPayable'] = Number(obj.CumulativeTaxPayable)
      item['Answer_ShouldTaxMount'] = Number(obj.CumulativeTaxPayable)
    }
    return {...item}
  })
  taxStore.setUserAnswer(userAnswer.value)
}

function incomeChange(val, row) {
  let Answer_CurrentIncome = new Big(row.Answer_CurrentIncome || 0)
  let CumulativeTaxableIncome = Answer_CurrentIncome.minus(row.CumulativeExpenseReduction || 0).minus(row.total_kc || 0)
  if (!CumulativeTaxableIncome.gt(0)) {
    CumulativeTaxableIncome = new Big(0)
  }
  let yearIncome = CumulativeTaxableIncome;
  let TaxRate = '3%'
  let CalculateDeductionsQuickly = 0
  if (!yearIncome.gt(36000)) {
    TaxRate = '3%'
    CalculateDeductionsQuickly = 0
  } else if (yearIncome.gt(36000) && !yearIncome.gt(144000)) {
    TaxRate = '10%'
    CalculateDeductionsQuickly = 2520
  } else if (yearIncome.gt(144000) && !yearIncome.gt(300000)) {
    TaxRate = '20%'
    CalculateDeductionsQuickly = 16920
  } else if (yearIncome.gt(300000) && !yearIncome.gt(420000)) {
    TaxRate = '25%'
    CalculateDeductionsQuickly = 31920
  } else if (yearIncome.gt(420000) && !yearIncome.gt(660000)) {
    TaxRate = '30%'
    CalculateDeductionsQuickly = 52920
  } else if (yearIncome.gt(660000) && !yearIncome.gt(960000)) {
    TaxRate = '35%'
    CalculateDeductionsQuickly = 85920
  } else if (yearIncome.gt(960000)) {
    TaxRate = '45%'
    CalculateDeductionsQuickly = 181920
  }
  row.TaxRate = TaxRate;
  row.CalculateDeductionsQuickly = CalculateDeductionsQuickly;
  row.CumulativeTaxableIncome = CumulativeTaxableIncome.valueOf();
  row.CumulativeTaxPayable = Number(CumulativeTaxableIncome.times(new Big(TaxRate.replace('%', '')).div(100)).minus(CalculateDeductionsQuickly).toString()).toFixed(2);
  save()
  return row
}

const currentItem = ref('')
const maxHeight = ref('300px')

onMounted(() => {
  maxHeight.value = ((window.innerHeight | document.documentElement.clientHeight | document.documentElement.clientHeight) - 290) + 'px'
})

function changeItem() {
  if (currentItem.value == '正常工资薪金所得') {
    genTableList()
  }
}

const emits = defineEmits(['changeTab'])
const changeTab = () => {
  emits('changeTab', 'one')
}
onBeforeUnmount(() => {
  save()
})

</script>

<style lang="scss" scoped>
.wrap_two {
  width: 100%;

  .type {
    height: 60px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      height: 20px;
      border-left: 4px solid var(--el-color-primary);
      box-sizing: border-box;
      line-height: 20px;
      text-indent: 12px;
    }
  }

  .opt-btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .opera-bar {
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    .grow {
      flex-grow: 1;
    }

    .item {
      margin-right: 30px;

      &.last {
        margin-right: 0;
      }
    }
  }
}
</style>
